import { apiGet, apiPost } from './utils';

export interface AISuggestion {
  uuid: string;
  key: string;
  request_uuid: string;
  suggestion_type: string;
  content: string;
  model_name: string;
  accepted: boolean | null;
  edited: boolean | null;
  edit_distance: number | null;
  discarded: boolean | null;
  confidence: number | null;
  date_created: string;
}

export interface AIAssessment {
  assessment: AISuggestion | null;
  status?: string;
}

export interface FieldGuideSuggestionEntry {
  section_name: string;
  title: string;
  content: string;
  uuid: string;
  slug: string;
  section_slug: string;
}

export const aiApi = {
  async suggestResponse(requestKey: string): Promise<{ job_id: string; status: string }> {
    return apiPost<{ job_id: string; status: string }>('/ai/suggest-response', {
      request: requestKey,
    });
  },

  async getSuggestions(requestUuid: string, suggestionType?: string): Promise<{ items: AISuggestion[] }> {
    return apiGet<{ items: AISuggestion[] }>(`/ai/suggestion/${requestUuid}`, {
      suggestion_type: suggestionType,
    });
  },

  async trackSuggestion(
    suggestionUuid: string,
    action: 'accepted' | 'edited' | 'discarded',
    editDistance?: number,
  ): Promise<AISuggestion> {
    return apiPost<AISuggestion>(`/ai/suggestion/${suggestionUuid}/track`, {
      action,
      edit_distance: editDistance,
    });
  },

  async getAssessment(requestUuid: string): Promise<AIAssessment> {
    return apiGet<AIAssessment>(`/ai/assessment/${requestUuid}`);
  },

  async getFieldguideSuggestions(requestKey: string): Promise<{ suggestion?: AISuggestion; job_id?: string; status?: string }> {
    return apiGet<{ suggestion?: AISuggestion; job_id?: string; status?: string }>('/ai/fieldguide-suggest', {
      request: requestKey,
    });
  },

  async classify(requestKey: string): Promise<{ classification?: AISuggestion; job_id?: string; status?: string }> {
    return apiPost<{ classification?: AISuggestion; job_id?: string; status?: string }>('/ai/classify', {
      request: requestKey,
    });
  },

  async getTriage(requestUuid: string): Promise<{ triage: TriageResult | null }> {
    return apiGet<{ triage: TriageResult | null }>(`/ai/triage/${requestUuid}`);
  },

  async correctTriage(requestUuid: string, categories: string[]): Promise<{ triage: TriageResult }> {
    return apiPost<{ triage: TriageResult }>(`/ai/triage/${requestUuid}/correct`, {
      categories: categories.join(','),
    });
  },
};

export interface TriageCategory {
  id: string;
  name: string;
  description: string;
}

export interface TriageResult {
  uuid: string;
  request_uuid: string;
  categories: string[];
  category_details: TriageCategory[];
  ai_generated: boolean;
  corrected: boolean;
}
